/*
  Etsy-style storefront helpers (Hihi Global):
  - Favorites: heart buttons on product cards, persisted in localStorage "etsy-favorites"
  - Recently viewed: records product handles on /products/* pages in localStorage
    "etsy-recently-viewed" and renders mini cards inside sections/recently-viewed.liquid
  Vanilla JS, no dependencies. Safe to load multiple times (window flag guard).
*/
(function () {
  'use strict';

  if (window.EtsyStorefrontInit) return;
  window.EtsyStorefrontInit = true;

  var FAV_KEY = 'etsy-favorites';
  var RV_KEY = 'etsy-recently-viewed';
  var RV_MAX_STORED = 12;
  var RV_MAX_RENDERED = 8;

  function readList(key) {
    try {
      var value = JSON.parse(window.localStorage.getItem(key));
      return Array.isArray(value) ? value.filter(function (item) {
        return typeof item === 'string' && item.length > 0;
      }) : [];
    } catch (error) {
      return [];
    }
  }

  function writeList(key, list) {
    try {
      window.localStorage.setItem(key, JSON.stringify(list));
    } catch (error) {
      /* storage unavailable: fail silently */
    }
  }

  /* Inlined so mini cards built in JS can reuse Dawn's quick-add markup:
     product-form.js and quick-add.js both toggle .loading__spinner. */
  var SPINNER_HTML =
    '<div class="loading__spinner hidden">' +
    '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">' +
    '<circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>' +
    '</div>';

  var CLOSE_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">' +
    '<path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/></svg>';

  var uid = 0;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function t(key, fallback) {
    var strings = window.variantStrings || {};
    return strings[key] || fallback;
  }

  /* ModalDialog.connectedCallback() moves quick-add modals to <body>, so a
     section that re-renders its grid has to delete its own leftovers by hand. */
  function ownerToken(section) {
    if (!section.dataset.etsyQaToken) {
      uid += 1;
      section.dataset.etsyQaToken = 'etsy-qa-' + uid;
    }
    return section.dataset.etsyQaToken;
  }

  function clearQuickAddModals(token) {
    document.querySelectorAll('[data-etsy-quick-add-owner="' + token + '"]').forEach(function (node) {
      node.remove();
    });
  }

  function route(key, fallback) {
    var routes = window.routes || {};
    return routes[key] || fallback;
  }

  /* ------------------------------ */
  /* Favorites                      */
  /* ------------------------------ */
  function syncFavoriteButtons(root) {
    var favorites = readList(FAV_KEY);
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-etsy-fav]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle') || button.getAttribute('data-etsy-fav');
      var active = favorites.indexOf(handle) !== -1;
      button.classList.toggle('etsy-fav-btn--active', active);
      button.classList.toggle('is-favorited', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var labelNode = button.querySelector('[data-etsy-fav-label]');
      if (labelNode) {
        labelNode.textContent = active ? 'Added to favorites' : 'Add to favorites';
      } else {
        button.setAttribute('aria-label', active ? 'Remove from favorites' : 'Add to favorites');
      }
    });
  }

  /* Event delegation so cards added later (sliders, section reloads) work too */
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-etsy-fav]') : null;
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    var handle = button.getAttribute('data-product-handle') || button.getAttribute('data-etsy-fav');
    if (!handle) return;
    var favorites = readList(FAV_KEY);
    var index = favorites.indexOf(handle);
    if (index === -1) {
      favorites.unshift(handle);
    } else {
      favorites.splice(index, 1);
    }
    writeList(FAV_KEY, favorites);
    syncFavoriteButtons(document);
    refreshFavoritesSections();
  });

  /* Restore state for cards rendered after initial load */
  var favObserverTimer = null;
  function scheduleFavSync() {
    if (favObserverTimer) return;
    favObserverTimer = window.setTimeout(function () {
      favObserverTimer = null;
      syncFavoriteButtons(document);
    }, 150);
  }

  function startFavObserver() {
    if (!('MutationObserver' in window) || !document.body) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleFavSync();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------ */
  /* Recently viewed: record        */
  /* ------------------------------ */
  function recordProductView() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return;
    var handle;
    try {
      handle = decodeURIComponent(match[1]);
    } catch (error) {
      handle = match[1];
    }
    if (!handle) return;
    var list = readList(RV_KEY).filter(function (item) {
      return item !== handle;
    });
    list.unshift(handle);
    writeList(RV_KEY, list.slice(0, RV_MAX_STORED));
  }

  /* ------------------------------ */
  /* Recently viewed: render        */
  /* ------------------------------ */
  function formatMoney(cents, symbol) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    return (symbol || '$') + amount;
  }

  function imageUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* Etsy-style quick add. Returns { pill, modal } so the modal can be parked
     outside the hover-gated overlay (and outside the media's overflow:hidden),
     while <modal-opener> still finds it via a document-wide querySelector. */
  function buildQuickAdd(product, url, token) {
    if (!product || !product.id) return null;

    var addLabel = t('addToCart', 'Add to cart');
    var pill = document.createElement('div');
    pill.className = 'etsy-mini-card__quick-add';

    var variants = product.variants || [];
    var modal = null;

    if (!product.available || variants.length === 0) {
      pill.innerHTML =
        '<div class="quick-add no-js-hidden">' +
        '<button type="button" class="quick-add__submit button button--full-width button--secondary" disabled>' +
        '<span>' + escapeHtml(t('soldOut', 'Sold out')) + '</span>' +
        '</button>' +
        '</div>';
      return { pill: pill, modal: null };
    }

    uid += 1;
    var id = 'EtsyMiniAdd-' + product.id + '-' + uid;
    var title = escapeHtml(product.title || '');

    if (variants.length > 1) {
      /* Reuses quick-add.js: it fetches data-product-url and injects <product-info>. */
      pill.innerHTML =
        '<div class="quick-add no-js-hidden">' +
        '<modal-opener data-modal="#' + id + '">' +
        '<button id="' + id + '-submit" type="button" name="add"' +
        ' class="quick-add__submit button button--full-width button--secondary"' +
        ' aria-haspopup="dialog" aria-label="' + escapeHtml(addLabel) + ' \u2014 ' + title + '"' +
        ' data-product-url="' + escapeHtml(url) + '">' +
        escapeHtml(addLabel) + SPINNER_HTML +
        '</button>' +
        '</modal-opener>' +
        '</div>';

      modal = document.createElement('div');
      modal.innerHTML =
        '<quick-add-modal id="' + id + '" class="quick-add-modal"' +
        ' data-etsy-quick-add-owner="' + escapeHtml(token) + '">' +
        '<div role="dialog" aria-label="' + title + '" aria-modal="true"' +
        ' class="quick-add-modal__content global-settings-popup" tabindex="-1">' +
        '<button id="ModalClose-' + id + '" type="button" class="quick-add-modal__toggle"' +
        ' aria-label="Close">' + CLOSE_SVG + '</button>' +
        '<div id="QuickAddInfo-' + id + '" class="quick-add-modal__content-info"></div>' +
        '</div>' +
        '</quick-add-modal>';
      modal = modal.firstChild;
      return { pill: pill, modal: modal };
    }

    /* Single variant: a real product form, so product-form.js handles the add
       (and the redirect to /cart this store uses, cart_type = page). */
    pill.innerHTML =
      '<div class="quick-add no-js-hidden">' +
      '<product-form>' +
      '<form method="post" action="' + escapeHtml(route('cart_add_url', '/cart/add')) + '"' +
      ' accept-charset="UTF-8" class="form" enctype="multipart/form-data"' +
      ' novalidate="novalidate" data-type="add-to-cart-form">' +
      '<input type="hidden" name="form_type" value="product">' +
      '<input type="hidden" name="utf8" value="\u2713">' +
      '<input type="hidden" name="id" class="product-variant-id" value="' + variants[0].id + '">' +
      '<button id="' + id + '-submit" type="submit" name="add"' +
      ' class="quick-add__submit button button--full-width button--secondary"' +
      ' aria-live="polite" data-sold-out-message="true"' +
      ' aria-label="' + escapeHtml(addLabel) + ' \u2014 ' + title + '">' +
      '<span>' + escapeHtml(addLabel) + '</span>' +
      '<span class="sold-out-message hidden">' + escapeHtml(t('soldOut', 'Sold out')) + '</span>' +
      SPINNER_HTML +
      '</button>' +
      '</form>' +
      '</product-form>' +
      '</div>';

    return { pill: pill, modal: null };
  }

  function buildMiniCard(product, symbol, withFav, token) {
    var item = document.createElement('li');
    if (withFav) item.className = 'etsy-mini-card__item--fav';

    var url = product.url || '/products/' + product.handle;

    var card = document.createElement('div');
    card.className = 'etsy-mini-card';

    var media = document.createElement('div');
    media.className = 'etsy-mini-card__media';
    if (withFav) {
      var fav = document.createElement('button');
      fav.type = 'button';
      fav.className = 'etsy-fav-btn etsy-fav-btn--active is-favorited etsy-mini-card__fav';
      fav.setAttribute('data-etsy-fav', '');
      fav.setAttribute('data-product-handle', product.handle);
      fav.setAttribute('aria-pressed', 'true');
      fav.setAttribute('aria-label', 'Remove from favorites');
      fav.innerHTML =
        '<span class="etsy-fav-icon etsy-fav-icon--outline" aria-hidden="true">&#9825;</span>' +
        '<span class="etsy-fav-icon etsy-fav-icon--filled" aria-hidden="true">&#9829;</span>';
      media.appendChild(fav);
    }
    var image = product.featured_image || (product.images && product.images[0]);
    if (image) {
      var img = document.createElement('img');
      img.className = 'etsy-mini-card__img';
      img.src = imageUrl(image, 400);
      img.srcset = [200, 400, 600]
        .map(function (width) {
          return imageUrl(image, width) + ' ' + width + 'w';
        })
        .join(', ');
      img.sizes = withFav
        ? '(min-width: 990px) 270px, (min-width: 750px) 33vw, 50vw'
        : '(min-width: 750px) 200px, 156px';
      img.alt = product.title || '';
      img.loading = 'lazy';
      /* Square attributes reserve the box before load; CSS height:auto keeps them
         from overriding aspect-ratio. */
      img.width = 400;
      img.height = 400;
      media.appendChild(img);
    }

    var quickAdd = buildQuickAdd(product, url, token);
    if (quickAdd) media.appendChild(quickAdd.pill);

    card.appendChild(media);

    /* The title holds the only link; .etsy-mini-card__link::after stretches it
       over the whole card so the overlay buttons can sit above it. */
    var title = document.createElement('p');
    title.className = 'etsy-mini-card__title';
    var link = document.createElement('a');
    link.className = 'etsy-mini-card__link';
    link.href = url;
    link.textContent = product.title || '';
    title.appendChild(link);
    card.appendChild(title);

    var price = document.createElement('p');
    price.className = 'etsy-mini-card__price';
    var onSale = product.compare_at_price && product.compare_at_price > product.price;
    if (onSale) price.classList.add('etsy-mini-card__price--sale');
    price.textContent = formatMoney(product.price, symbol);
    if (onSale) {
      var compare = document.createElement('s');
      compare.className = 'etsy-mini-card__compare';
      compare.textContent = formatMoney(product.compare_at_price, symbol);
      price.appendChild(compare);
    }
    card.appendChild(price);

    item.appendChild(card);
    if (quickAdd && quickAdd.modal) item.appendChild(quickAdd.modal);
    return item;
  }

  function renderRecentlyViewed(section) {
    if (!section || section.getAttribute('data-etsy-rv-rendered') === 'true') return;
    section.setAttribute('data-etsy-rv-rendered', 'true');

    var grid = section.querySelector('[data-etsy-rv-grid]');
    if (!grid) return;

    var symbol = section.getAttribute('data-currency-symbol') || '$';
    var token = ownerToken(section);
    var handles = readList(RV_KEY).slice(0, RV_MAX_RENDERED);
    if (handles.length === 0) return;

    var requests = handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (response) {
        if (!response.ok) throw new Error('Not found: ' + handle);
        return response.json();
      });
    });

    Promise.allSettled(requests).then(function (results) {
      var fragment = document.createDocumentFragment();
      var count = 0;
      results.forEach(function (result) {
        if (result.status !== 'fulfilled' || !result.value) return;
        fragment.appendChild(buildMiniCard(result.value, symbol, false, token));
        count += 1;
      });
      if (count > 0) {
        clearQuickAddModals(token);
        grid.innerHTML = '';
        grid.appendChild(fragment);
        section.removeAttribute('hidden');
        setupArrows(section, grid);
      }
    });
  }

  /* Horizontal arrows: only meaningful once the row is visible and populated,
     because a hidden element reports clientWidth 0. */
  function setupArrows(section, grid) {
    var prev = section.querySelector('[data-etsy-rv-prev]');
    var next = section.querySelector('[data-etsy-rv-next]');
    if (!prev || !next) return;

    function step() {
      var items = grid.children;
      var pitch = items.length > 1
        ? items[1].offsetLeft - items[0].offsetLeft
        : (items.length ? items[0].offsetWidth : 0);
      if (pitch <= 0) return grid.clientWidth;
      return Math.max(pitch, Math.floor(grid.clientWidth / pitch) * pitch);
    }

    function update() {
      var max = grid.scrollWidth - grid.clientWidth;
      var scrollable = max > 1;
      prev.hidden = !scrollable || grid.scrollLeft <= 1;
      next.hidden = !scrollable || grid.scrollLeft >= max - 1;
    }

    prev.addEventListener('click', function () {
      grid.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      grid.scrollBy({ left: step(), behavior: 'smooth' });
    });
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initRecentlyViewedSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-etsy-recently-viewed]').forEach(renderRecentlyViewed);
  }

  /* ------------------------------ */
  /* Favorites page: render         */
  /* ------------------------------ */
  function renderFavorites(section) {
    if (!section) return;
    var grid = section.querySelector('[data-etsy-fav-grid]');
    var empty = section.querySelector('[data-etsy-fav-empty]');
    if (!grid) return;

    var symbol = section.getAttribute('data-currency-symbol') || '$';
    var token = ownerToken(section);
    var handles = readList(FAV_KEY).slice(0, 48);

    if (handles.length === 0) {
      clearQuickAddModals(token);
      grid.innerHTML = '';
      if (empty) empty.removeAttribute('hidden');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');

    var requests = handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (response) {
        if (!response.ok) throw new Error('Not found: ' + handle);
        return response.json();
      });
    });

    Promise.allSettled(requests).then(function (results) {
      var fragment = document.createDocumentFragment();
      var count = 0;
      results.forEach(function (result) {
        if (result.status !== 'fulfilled' || !result.value) return;
        fragment.appendChild(buildMiniCard(result.value, symbol, true, token));
        count += 1;
      });
      clearQuickAddModals(token);
      grid.innerHTML = '';
      if (count > 0) {
        grid.appendChild(fragment);
      } else if (empty) {
        empty.removeAttribute('hidden');
      }
    });
  }

  function initFavoritesSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-etsy-favorites]').forEach(renderFavorites);
  }

  /* Re-render favorites grids after a heart toggle (remove card instantly) */
  function refreshFavoritesSections() {
    document.querySelectorAll('[data-etsy-favorites]').forEach(renderFavorites);
  }

  /* ------------------------------ */
  /* Boot                           */
  /* ------------------------------ */
  function boot() {
    recordProductView();
    syncFavoriteButtons(document);
    startFavObserver();
    initRecentlyViewedSections(document);
    initFavoritesSections(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-render when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target || document;
    target.querySelectorAll('[data-etsy-recently-viewed]').forEach(function (section) {
      section.removeAttribute('data-etsy-rv-rendered');
      if (section.dataset.etsyQaToken) clearQuickAddModals(section.dataset.etsyQaToken);
    });
    initRecentlyViewedSections(target);
    syncFavoriteButtons(document);
  });
})();
